import React from 'react';

import {
  FormControlLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { InactiveReason } from 'typings';
import { InactiveReasons } from 'utils/constants';

interface DialogProps {
  open: boolean;
  onSubmit: (reason: string) => void;
  onCancel: () => void;
}

function InactiveReasonsRadioGroup({ inactiveReason, onRadioSelect }: any) {
  const handleChange = (event: any) => {
    onRadioSelect(event.target.value);
  };

  const reasonRadios = InactiveReasons.map((reason: InactiveReason) => (
    <FormControlLabel
      key={reason.value}
      value={reason.value}
      control={<Radio />}
      label={reason.text}
    />
  ));

  return (
    <RadioGroup
      aria-label="inactive reason"
      name="inactive_reason"
      value={inactiveReason}
      onChange={handleChange}
    >
      {reasonRadios}
    </RadioGroup>
  );
}

const InactiveDialog = ({ open, onCancel, onSubmit }: DialogProps) => {
  const [inactiveReason, onRadioSelect] = React.useState('');
  return (
    <Dialog aria-labelledby="inactive-dialog" open={open}>
      <DialogTitle>Inactive Reason</DialogTitle>
      <DialogContent>
        <InactiveReasonsRadioGroup inactiveReason={inactiveReason} onRadioSelect={onRadioSelect} />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => onSubmit(inactiveReason)}
          disabled={inactiveReason === ''}
          autoFocus
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactiveDialog;
